import { jsxs, jsx } from 'react/jsx-runtime';
import { Text, Image, Video } from '@zhiyun-web/components';
import { useRef, useEffect } from 'react';
import gsap, { gsap as gsap$1 } from 'gsap';
import ScrollTrigger, { ScrollTrigger as ScrollTrigger$1 } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Observer } from 'gsap/Observer';
import { useSprings, useSpring, animated } from '@react-spring/web';
import { useMediaQuery } from 'react-responsive';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$B =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails$c = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$b = fails$c;

var functionBindNative = !fails$b(function () {
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind$5 = FunctionPrototype$2.bind;
var call$b = FunctionPrototype$2.call;
var uncurryThis$e = NATIVE_BIND$3 && bind$5.bind(call$b, call$b);

var functionUncurryThis = NATIVE_BIND$3 ? function (fn) {
  return fn && uncurryThis$e(fn);
} : function (fn) {
  return fn && function () {
    return call$b.apply(fn, arguments);
  };
};

var uncurryThis$d = functionUncurryThis;

var toString$1 = uncurryThis$d({}.toString);
var stringSlice = uncurryThis$d(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var global$A = global$B;
var uncurryThis$c = functionUncurryThis;
var fails$a = fails$c;
var classof$4 = classofRaw$1;

var Object$5 = global$A.Object;
var split = uncurryThis$c(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) == 'String' ? split(it, '') : Object$5(it);
} : Object$5;

var global$z = global$B;

var TypeError$e = global$z.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError$e("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var shared$3 = {exports: {}};

var global$y = global$B;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$3 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$3(global$y, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$y[key] = value;
  } return value;
};

var global$x = global$B;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$x[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.21.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.21.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var global$w = global$B;
var requireObjectCoercible = requireObjectCoercible$2;

var Object$4 = global$w.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return Object$4(requireObjectCoercible(argument));
};

var uncurryThis$b = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$b({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$a = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString = uncurryThis$a(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$h = function (argument) {
  return typeof argument == 'function';
};

var global$v = global$B;
var isCallable$g = isCallable$h;

var aFunction = function (argument) {
  return isCallable$g(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$v[namespace]) : global$v[namespace] && global$v[namespace][method];
};

var getBuiltIn$6 = getBuiltIn$7;

var engineUserAgent = getBuiltIn$6('navigator', 'userAgent') || '';

var global$u = global$B;
var userAgent$3 = engineUserAgent;

var process$3 = global$u.process;
var Deno = global$u.Deno;
var versions = process$3 && process$3.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$9 = fails$c;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$t = global$B;
var shared$2 = shared$3.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$t.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$e = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$9(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID$1 && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var isCallable$f = isCallable$h;

var isObject$7 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$f(it);
};

var global$s = global$B;
var isObject$6 = isObject$7;

var String$4 = global$s.String;
var TypeError$d = global$s.TypeError;

// `Assert: Type(argument) is Object`
var anObject$a = function (argument) {
  if (isObject$6(argument)) return argument;
  throw TypeError$d(String$4(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$8 = fails$c;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var DESCRIPTORS$9 = descriptors;
var fails$7 = fails$c;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$9 && fails$7(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var objectDefineProperty = {};

var global$r = global$B;
var isObject$5 = isObject$7;

var document$3 = global$r.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$5(document$3) && isObject$5(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$8 = descriptors;
var fails$6 = fails$c;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$8 && !fails$6(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var NATIVE_BIND$2 = functionBindNative;

var call$a = Function.prototype.call;

var functionCall = NATIVE_BIND$2 ? call$a.bind(call$a) : function () {
  return call$a.apply(call$a, arguments);
};

var uncurryThis$9 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$9({}.isPrototypeOf);

var global$q = global$B;
var getBuiltIn$5 = getBuiltIn$7;
var isCallable$e = isCallable$h;
var isPrototypeOf$2 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Object$3 = global$q.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$5('Symbol');
  return isCallable$e($Symbol) && isPrototypeOf$2($Symbol.prototype, Object$3(it));
};

var global$p = global$B;

var String$3 = global$p.String;

var tryToString$4 = function (argument) {
  try {
    return String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$o = global$B;
var isCallable$d = isCallable$h;
var tryToString$3 = tryToString$4;

var TypeError$c = global$o.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$5 = function (argument) {
  if (isCallable$d(argument)) return argument;
  throw TypeError$c(tryToString$3(argument) + ' is not a function');
};

var aCallable$4 = aCallable$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$4(func);
};

var global$n = global$B;
var call$9 = functionCall;
var isCallable$c = isCallable$h;
var isObject$4 = isObject$7;

var TypeError$b = global$n.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$c(fn = input.toString) && !isObject$4(val = call$9(fn, input))) return val;
  if (isCallable$c(fn = input.valueOf) && !isObject$4(val = call$9(fn, input))) return val;
  if (pref !== 'string' && isCallable$c(fn = input.toString) && !isObject$4(val = call$9(fn, input))) return val;
  throw TypeError$b("Can't convert object to primitive value");
};

var global$m = global$B;
var call$8 = functionCall;
var isObject$3 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$d = wellKnownSymbol$e;

var TypeError$a = global$m.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$d('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$8(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw TypeError$a("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$l = global$B;
var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$9 = anObject$a;
var toPropertyKey$1 = toPropertyKey$2;

var TypeError$9 = global$l.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey$1(P);
  anObject$9(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey$1(P);
  anObject$9(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$9('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var hiddenKeys$4 = {};

var uncurryThis$8 = functionUncurryThis;
var hasOwn$8 = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push = uncurryThis$8([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$8(hiddenKeys$3, key) && hasOwn$8(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$8(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$6 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$4 = objectDefineProperty;
var anObject$8 = anObject$a;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$6 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$8(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$4.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */

var anObject$7 = anObject$a;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$7(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$c = wellKnownSymbol$e;
var create$1 = objectCreate;
var definePropertyModule$3 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$c('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$3.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var uncurryThis$7 = functionUncurryThis;
var isCallable$b = isCallable$h;
var store$1 = sharedStore;

var functionToString = uncurryThis$7(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$b(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$k = global$B;
var isCallable$a = isCallable$h;
var inspectSource$3 = inspectSource$4;

var WeakMap$1 = global$k.WeakMap;

var nativeWeakMap = isCallable$a(WeakMap$1) && /native code/.test(inspectSource$3(WeakMap$1));

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$j = global$B;
var uncurryThis$6 = functionUncurryThis;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$7 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$8 = global$j.TypeError;
var WeakMap = global$j.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$8('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$6(store.get);
  var wmhas = uncurryThis$6(store.has);
  var wmset = uncurryThis$6(store.set);
  set$1 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$8(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw new TypeError$8(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$4 = descriptors;
var call$7 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey = toPropertyKey$2;
var hasOwn$6 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$6(O, P)) return createPropertyDescriptor$1(!call$7(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var redefine$5 = {exports: {}};

var DESCRIPTORS$3 = descriptors;
var hasOwn$5 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$3 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$5(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$3 || (DESCRIPTORS$3 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$i = global$B;
var isCallable$9 = isCallable$h;
var hasOwn$4 = hasOwnProperty_1;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var setGlobal$1 = setGlobal$3;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$2 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;

var getInternalState$2 = InternalStateModule$2.get;
var enforceInternalState = InternalStateModule$2.enforce;
var TEMPLATE = String(String).split('String');

(redefine$5.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$9(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn$4(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
      createNonEnumerableProperty$3(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$i) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$3(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$9(this) && getInternalState$2(this).source || inspectSource$2(this);
});

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$3 = getBuiltIn$7;
var uncurryThis$5 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$6 = anObject$a;

var concat$1 = uncurryThis$5([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$3('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$6(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$5 = fails$c;
var isCallable$8 = isCallable$h;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$8(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$h = global$B;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var redefine$4 = redefine$5.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$h;
  } else if (STATIC) {
    target = global$h[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$h[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$4(target, key, sourceProperty, options);
  }
};

var fails$4 = fails$c;

var correctPrototypeGetter = !fails$4(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$g = global$B;
var hasOwn$2 = hasOwnProperty_1;
var isCallable$7 = isCallable$h;
var toObject$1 = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$2 = global$g.Object;
var ObjectPrototype = Object$2.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$2.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$7(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$2 ? ObjectPrototype : null;
};

var fails$3 = fails$c;
var isCallable$6 = isCallable$h;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$3 = redefine$5.exports;
var wellKnownSymbol$b = wellKnownSymbol$e;

var ITERATOR$5 = wellKnownSymbol$b('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$3(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$6(IteratorPrototype$2[ITERATOR$5])) {
  redefine$3(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$a = wellKnownSymbol$e;

var TO_STRING_TAG$3 = wellKnownSymbol$a('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var global$f = global$B;
var isCallable$5 = isCallable$h;

var String$2 = global$f.String;
var TypeError$7 = global$f.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$5(argument)) return argument;
  throw TypeError$7("Can't set " + String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$4 = functionUncurryThis;
var anObject$5 = anObject$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$4(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$5(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$2 = _export;
var call$6 = functionCall;
var FunctionName = functionName;
var isCallable$4 = isCallable$h;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var redefine$2 = redefine$5.exports;
var wellKnownSymbol$9 = wellKnownSymbol$e;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$9('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$4(CurrentIteratorPrototype[ITERATOR$4])) {
          redefine$2(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$6(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    redefine$2(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = defineIterator$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$e = global$B;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var wellKnownSymbol$8 = wellKnownSymbol$e;

var ITERATOR$3 = wellKnownSymbol$8('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$8('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$e[COLLECTION_NAME] && global$e[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var global$d = global$B;

var nativePromiseConstructor = global$d.Promise;

var redefine$1 = redefine$5.exports;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$1(target, key, src[key], options);
  return target;
};

var getBuiltIn$2 = getBuiltIn$7;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$7 = wellKnownSymbol$e;
var DESCRIPTORS$1 = descriptors;

var SPECIES$2 = wellKnownSymbol$7('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var global$c = global$B;
var isPrototypeOf$1 = objectIsPrototypeOf;

var TypeError$6 = global$c.TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$1(Prototype, it)) return it;
  throw TypeError$6('Incorrect invocation');
};

var uncurryThis$3 = functionUncurryThis;
var aCallable$3 = aCallable$5;
var NATIVE_BIND$1 = functionBindNative;

var bind$4 = uncurryThis$3(uncurryThis$3.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$3(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$6 = wellKnownSymbol$e;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$6('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var wellKnownSymbol$5 = wellKnownSymbol$e;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var global$b = global$B;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$3 = isCallable$h;
var classofRaw = classofRaw$1;
var wellKnownSymbol$4 = wellKnownSymbol$e;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var Object$1 = global$b.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$3 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$1(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$3(O.callee) ? 'Arguments' : result;
};

var classof$2 = classof$3;
var getMethod$1 = getMethod$3;
var Iterators = iterators;
var wellKnownSymbol$3 = wellKnownSymbol$e;

var ITERATOR$1 = wellKnownSymbol$3('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof$2(it)];
};

var global$a = global$B;
var call$5 = functionCall;
var aCallable$2 = aCallable$5;
var anObject$4 = anObject$a;
var tryToString$2 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var TypeError$5 = global$a.TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$2(iteratorMethod)) return anObject$4(call$5(iteratorMethod, argument));
  throw TypeError$5(tryToString$2(argument) + ' is not iterable');
};

var call$4 = functionCall;
var anObject$3 = anObject$a;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$3(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$4(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$3(innerResult);
  return value;
};

var global$9 = global$B;
var bind$3 = functionBindContext;
var call$3 = functionCall;
var anObject$2 = anObject$a;
var tryToString$1 = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$2;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var TypeError$4 = global$9.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$1 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$3(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$2(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError$4(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$3(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$2 = wellKnownSymbol$e;

var ITERATOR = wellKnownSymbol$2('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var uncurryThis$2 = functionUncurryThis;
var fails$2 = fails$c;
var isCallable$2 = isCallable$h;
var classof$1 = classof$3;
var getBuiltIn$1 = getBuiltIn$7;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$2(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$2(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$2(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$8 = global$B;
var isConstructor = isConstructor$1;
var tryToString = tryToString$4;

var TypeError$3 = global$8.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError$3(tryToString(argument) + ' is not a constructor');
};

var anObject$1 = anObject$a;
var aConstructor = aConstructor$1;
var wellKnownSymbol$1 = wellKnownSymbol$e;

var SPECIES$1 = wellKnownSymbol$1('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$1(O).constructor;
  var S;
  return C === undefined || (S = anObject$1(C)[SPECIES$1]) == undefined ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$2 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$2.bind(apply$1) : function () {
  return call$2.apply(apply$1, arguments);
});

var uncurryThis$1 = functionUncurryThis;

var arraySlice$1 = uncurryThis$1([].slice);

var global$7 = global$B;

var TypeError$2 = global$7.TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw TypeError$2('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var classof = classofRaw$1;
var global$6 = global$B;

var engineIsNode = classof(global$6.process) == 'process';

var global$5 = global$B;
var apply = functionApply;
var bind$2 = functionBindContext;
var isCallable$1 = isCallable$h;
var hasOwn = hasOwnProperty_1;
var fails$1 = fails$c;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$2 = engineIsNode;

var set = global$5.setImmediate;
var clear = global$5.clearImmediate;
var process$2 = global$5.process;
var Dispatch = global$5.Dispatch;
var Function$1 = global$5.Function;
var MessageChannel = global$5.MessageChannel;
var String$1 = global$5.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$5.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$5.postMessage(String$1(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$1(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$1[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$2) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$2(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$5.addEventListener &&
    isCallable$1(global$5.postMessage) &&
    !global$5.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$1(post)
  ) {
    defer = post;
    global$5.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$4 = global$B;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$4.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$3 = global$B;
var bind$1 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$1 = engineIsNode;

var MutationObserver = global$3.MutationObserver || global$3.WebKitMutationObserver;
var document$2 = global$3.document;
var process$1 = global$3.process;
var Promise$1 = global$3.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$3, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$1 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$1(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$1) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$1(macrotask, global$3);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aCallable$1 = aCallable$5;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$1(resolve);
  this.reject = aCallable$1(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject = anObject$a;
var isObject$1 = isObject$7;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$2 = global$B;

var hostReportErrors$1 = function (a, b) {
  var console = global$2.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var engineIsBrowser = typeof window == 'object';

var $$1 = _export;
var global$1 = global$B;
var getBuiltIn = getBuiltIn$7;
var call$1 = functionCall;
var NativePromise = nativePromiseConstructor;
var redefine = redefine$5.exports;
var redefineAll = redefineAll$1;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var aCallable = aCallable$5;
var isCallable = isCallable$h;
var isObject = isObject$7;
var anInstance = anInstance$1;
var inspectSource = inspectSource$4;
var iterate = iterate$1;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var Queue = queue;
var InternalStateModule = internalState;
var isForced = isForced_1;
var wellKnownSymbol = wellKnownSymbol$e;
var IS_BROWSER = engineIsBrowser;
var IS_NODE = engineIsNode;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';

var getInternalState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError$1 = global$1.TypeError;
var document$1 = global$1.document;
var process = global$1.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$1.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable(global$1.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$1(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$1(task, global$1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$1(task, global$1, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$1(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call$1(Internal, this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    // eslint-disable-next-line unicorn/no-thenable -- safe
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      if (state.state == PENDING) state.reactions.add(reaction);
      else microtask(function () {
        callReaction(reaction, state);
      });
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$1(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$$1({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$$1({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call$1(capability.reject, undefined, r);
    return capability.promise;
  }
});

$$1({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$1({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$1($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call$1($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var DESCRIPTORS = descriptors;
var uncurryThis = functionUncurryThis;
var call = functionCall;
var fails = fails$c;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

var styles$2 = {"ctn":"carry-effect-auto-module_ctn__l6Ooj","modelItem":"carry-effect-auto-module_modelItem__w91-V","blurEffect":"carry-effect-auto-module_blurEffect__wNLs7","modelTextBox":"carry-effect-auto-module_modelTextBox__LSxEQ","triggers":"carry-effect-auto-module_triggers__w1xX-","trigger":"carry-effect-auto-module_trigger__-7clx","cameraStyleWrap":"carry-effect-auto-module_cameraStyleWrap__XxtWz","light":"carry-effect-auto-module_light__LQWat","modelBox":"carry-effect-auto-module_modelBox__xhQJQ","horizontalBox":"carry-effect-auto-module_horizontalBox__K-iyB","verticalBox":"carry-effect-auto-module_verticalBox__H54GL","idlerBox":"carry-effect-auto-module_idlerBox__fIpU6","cameraBox":"carry-effect-auto-module_cameraBox__mosfz","idlerItem":"carry-effect-auto-module_idlerItem__3pVBW","cameraItem":"carry-effect-auto-module_cameraItem__s2XVu","currentStateToggleButton":"carry-effect-auto-module_currentStateToggleButton__j9bex","tab":"carry-effect-auto-module_tab__aQuBr","horizontal":"carry-effect-auto-module_horizontal__nJDwn","horizontalText":"carry-effect-auto-module_horizontalText__I0S8n","verticalText":"carry-effect-auto-module_verticalText__Rn2CT","seeCameraListButton":"carry-effect-auto-module_seeCameraListButton__gLUmj","seeCameraListButtonMobile":"carry-effect-auto-module_seeCameraListButtonMobile__GV89n","textBox":"carry-effect-auto-module_textBox__tOayq","modelOperateBox":"carry-effect-auto-module_modelOperateBox__yVG1t","lineBox":"carry-effect-auto-module_lineBox__8vjD2","lineAnimation":"carry-effect-auto-module_lineAnimation__DHwFz","tabCtn":"carry-effect-auto-module_tabCtn__9xV05","content":"carry-effect-auto-module_content__BV-ns","describeMobile":"carry-effect-auto-module_describeMobile__TY-g3","operateBox":"carry-effect-auto-module_operateBox__xo7FG","lastButton":"carry-effect-auto-module_lastButton__G-etn","nextButton":"carry-effect-auto-module_nextButton__sb2EU","buttonBox":"carry-effect-auto-module_buttonBox__KsOTC","describe":"carry-effect-auto-module_describe__Mfh2t"};

gsap.registerPlugin(ScrollTrigger, Observer, ScrollToPlugin);
function CarryEffectAuto(props) {
  const {
    eyebrow,
    header,
    body,
    note,
    model,
    horizontalCombinations,
    verticalCombinations,
    textData,
    cameraNameAnimation = "transfer",
    trigger,
    markers = false,
    theme,
    href,
    align = "end"
  } = props;
  const ctnRef = useRef(null);
  const currentIndex = useRef(-1);
  const currentState = useRef("horizontal");
  const modelGSAPArray = useRef([]);
  const intentObserver = useRef();
  const preventScroll = useRef();
  const animating = useRef(false);
  useRef(0);
  const isSmallScreen = useMediaQuery({
    query: "(max-width: 1024px)"
  });
  const cameraDisplacements = isSmallScreen ? {
    horizontal: {
      x: -120,
      y: 48
    },
    vertical: {
      x: 160,
      y: 24
    }
  } : {
    horizontal: {
      x: -180,
      y: 72
    },
    vertical: {
      x: 240,
      y: 36
    }
  };
  // idlerAnimation
  const [idlerItemSprings, setIdlerItemSprings] = useSprings(horizontalCombinations.idler.length, i => {
    return {
      opacity: i <= currentIndex.current ? 1 : 0
    };
  });
  // cameraAnimationHorizontal
  const [cameraDisplacementHorizontalSprings, setCameraDisplacementHorizontalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      y: i === currentIndex.current && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.y,
      x: i === currentIndex.current && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.x,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  const [cameraOpacityHorizontalSprings, setCameraOpacityHorizontalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current && currentState.current === "horizontal" ? 1 : 0,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  // cameraAnimationVertical
  const [cameraDisplacementVerticalSprings, setCameraDisplacementVerticalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      y: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
      x: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  const [cameraOpacityVerticalSprings, setCameraOpacityVerticalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current && currentState.current === "vertical" ? 1 : 0,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current ? 1 : 0
    };
  });
  // vertical box animation
  const [verticalBoxOpacitySpring, setVerticalBoxOpacitySpring] = useSpring(() => {
    return {
      opacity: currentState.current === "horizontal" ? 0 : 1
    };
  });
  const [baseSprings, setBaseSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current ? 1 : 0,
      y: 0,
      x: 0
    };
  });
  useEffect(() => {
    const ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: ctnRef.current,
        start: "top 50%",
        onEnter: () => {
          console.log("Enter");
          nextWord();
        }
      });
    });
    return () => ctx.revert();
  }, []);
  useEffect(() => {
    const ctx = gsap.context(() => {
      modelGSAPArray.current = gsap.utils.toArray(`.${styles$2.modelItem}`);
      if (cameraNameAnimation === "blur") {
        gsap.set(modelGSAPArray.current, {
          opacity: i => i === currentIndex.current ? 1 : 0
        });
        gsap.set(document.querySelector(`.${styles$2.modelBox}`), {
          width: 0
        });
      }
      // create an observer and disable it to start
      // intentObserver.current = ScrollTrigger.observe({
      //   type: "wheel,touch",
      //   onUp: () =>
      //     !animating.current && animation(currentIndex.current + 1, true),
      //   onDown: () =>
      //     !animating.current && animation(currentIndex.current - 1, false),
      //   wheelSpeed: -1, // to match mobile behavior, invert the wheel speed
      //   tolerance: 10,
      //   preventDefault: true,
      //   onPress: (self) => {
      //     // on touch devices like iOS, if we want to prevent scrolling, we must call preventDefault() on the touchstart (Observer doesn't do that because that would also prevent side-scrolling which is undesirable in most cases)
      //     ScrollTrigger.isTouch && self.event.preventDefault();
      //   },
      // });
      // intentObserver.current.disable();
      // preventScroll.current = ScrollTrigger.observe({
      //   preventDefault: true,
      //   type: "wheel,scroll",
      //   allowClicks: true,
      //   onEnable: (self) => (scrollTop.current = self.scrollY()), // save the scroll position
      //   onChangeY: (self) => self.scrollY(scrollTop.current), // refuse to scroll
      // });
      // preventScroll.current.disable();
      // // pin swipe section and initiate observer
      // ScrollTrigger.create({
      //   trigger: trigger ?? ctnRef.current,
      //   pin: true,
      //   anticipatePin: 1,
      //   start: "top top",
      //   end: "+=0",
      //   markers: markers,
      //   onEnter: (self) => {
      //     if (preventScroll.current?.isEnabled === false) {
      //       self.scroll(self.start);
      //       preventScroll.current.enable();
      //       intentObserver.current?.enable();
      //       animation(currentIndex.current + 1, true);
      //     }
      //   },
      //   onEnterBack: (self) => {
      //     if (preventScroll.current?.isEnabled === false) {
      //       self.scroll(self.start);
      //       preventScroll.current.enable();
      //       intentObserver.current?.enable();
      //       animation(currentIndex.current - 1, false);
      //     }
      //   },
      // });
    });

    return () => ctx.revert();
  });
  const nextWord = () => {
    const index = (currentIndex.current + 1) % model.length;
    animation(index, false);
  };
  const prevWord = () => {
    const index = (currentIndex.current - 1 + model.length) % model.length;
    animation(index, true);
  };
  const animation = (index, isScrollingDown) => {
    var _a, _b, _c;
    console.log(index);
    animating.current = true;
    if (index === model.length && isScrollingDown || index === -1 && !isScrollingDown) {
      (_a = intentObserver.current) === null || _a === void 0 ? void 0 : _a.disable();
      (_b = preventScroll.current) === null || _b === void 0 ? void 0 : _b.disable();
      animating.current = false;
      // now make it go 1px beyond in the correct direction so that it doesn't trigger onEnter/onEnterBack.
      (_c = preventScroll.current) === null || _c === void 0 ? void 0 : _c.scrollY(preventScroll.current.scrollY() + (index === model.length ? 1 : -1));
      return;
    }
    setIdlerItemSprings.start(i => {
      return {
        opacity: i <= index ? 1 : 0
      };
    });
    setCameraDisplacementHorizontalSprings.start(i => {
      return {
        y: i === index && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.y,
        x: i === index && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: i === index && currentState.current === "horizontal" ? 600 : 0
      };
    });
    setCameraDisplacementVerticalSprings.start(i => {
      return {
        y: i === index && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
        x: i === index && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: i === index && currentState.current === "vertical" ? 600 : 0
      };
    });
    // setCameraOpacitySprings.start((i) => {
    //   if (currentIndex.current === i) {
    //     return {
    //       opacity: 0,
    //       delay: 300,
    //       config: { tension: 170, friction: 26 },
    //     };
    //   } else if (index === i) {
    //     return {
    //       opacity: 1,
    //       delay: 600,
    //       config: { tension: 170, friction: 26 },
    //     };
    //   }
    //   // return {
    //   //   opacity: i === index ? 1 : 0,
    //   //   delay: i === index ? 540 : 120,
    //   //   config: { tension: 170, friction: 26 },
    //   // };
    // });
    setCameraOpacityHorizontalSprings.start(i => {
      if (currentIndex.current === i && currentState.current === "horizontal") {
        return {
          opacity: 0,
          delay: 300,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else if (index === i && currentState.current === "horizontal") {
        return {
          opacity: 1,
          delay: 600,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else {
        return {
          opacity: 0
        };
      }
    });
    setCameraOpacityVerticalSprings.start(i => {
      if (currentIndex.current === i && currentState.current === "vertical") {
        return {
          opacity: 0,
          delay: 300,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else if (index === i && currentState.current === "vertical") {
        return {
          opacity: 1,
          delay: 600,
          config: {
            tension: 170,
            friction: 26
          }
        };
      }
    });
    setBaseSprings.start(i => {
      var _a;
      if (currentIndex.current === i) {
        return {
          opacity: 0,
          // delay: 540,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else if (index === i && currentState.current === "horizontal") {
        return {
          opacity: 1,
          delay: (_a = horizontalCombinations.camera[i].cameraStatic[0].delay) !== null && _a !== void 0 ? _a : 0,
          config: {
            tension: 170,
            friction: 26
          }
        };
      }
    });
    if (cameraNameAnimation === "blur") {
      gsap.to(modelGSAPArray.current, {
        opacity: i => i === index ? 1 : 0,
        filter: i => i === index ? "blur(0px)" : "blur(40px)",
        duration: 1
      });
      gsap.to(document.querySelector(`.${styles$2.modelBox}`), {
        width: modelGSAPArray.current[index].clientWidth,
        duration: 1,
        onComplete: () => {
          animating.current = false;
        }
      });
    } else {
      gsap.to(modelGSAPArray.current, {
        yPercent: -100 * index,
        duration: 0.8,
        onComplete: () => {
          animating.current = false;
        }
      });
    }
    setTabActiveClassName(index);
    currentIndex.current = index;
  };
  const toVertical = () => {
    setTabActiveClassName(currentIndex.current);
    animating.current = true;
    currentState.current = "vertical";
    // 控制整体的横拍竖拍盒子的不透明度
    setVerticalBoxOpacitySpring.start(() => {
      return {
        opacity: 1,
        delay: 300
      };
    });
    // 控制横拍的相机不透明度动画（消失）
    setCameraOpacityHorizontalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "horizontal" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 300
      };
    });
    // 控制横拍的相机位移动画（卸掉）
    setCameraDisplacementHorizontalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.y : cameraDisplacements.horizontal.y,
        x: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.x : cameraDisplacements.horizontal.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 120
      };
    });
    // 控制竖拍的相机不透明度动画（出现）
    setCameraOpacityVerticalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "vertical" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    setBaseSprings.start(i => {
      return {
        y: cameraDisplacements.vertical.y,
        x: cameraDisplacements.vertical.x,
        opacity: 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 120
      };
    });
    // 控制竖拍的相机位移动画（装上）
    setCameraDisplacementVerticalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
        x: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600,
        onRest: () => {
          animating.current = false;
        }
      };
    });
  };
  const toHorizontal = () => {
    setTabActiveClassName(currentIndex.current);
    currentState.current = "horizontal";
    // setBaseSprings.start((i) => {
    //   if (currentIndex.current === i) {
    //     return {
    //       opacity: 0,
    //       delay: 540,
    //       config: { tension: 170, friction: 26 },
    //     };
    //   }
    // });
    setVerticalBoxOpacitySpring.start(() => {
      return {
        opacity: 0,
        delay: 300
      };
    });
    setCameraOpacityHorizontalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "horizontal" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    // 这个持续时间为 0 的动画是为了让当前 index 的起始偏移改为从左侧开始，保证在横竖拍切换时，起始位置总为从左侧滑入
    setCameraDisplacementHorizontalSprings.start(i => {
      if (i === currentIndex.current) {
        return {
          y: cameraDisplacements.vertical.y,
          x: cameraDisplacements.vertical.x,
          config: {
            tension: 0,
            friction: 0
          }
        };
      }
    });
    setCameraDisplacementHorizontalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.y : cameraDisplacements.horizontal.y,
        x: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.x : cameraDisplacements.horizontal.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    setCameraOpacityVerticalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "vertical" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 300
      };
    });
    setBaseSprings.start(i => {
      return {
        y: 0,
        x: 0,
        opacity: i === currentIndex.current ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    setCameraDisplacementVerticalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
        x: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
        config: {
          tension: 170,
          friction: 26
        },
        onRest: () => {
          animating.current = false;
        }
      };
    });
  };
  return jsxs("div", Object.assign({
    className: `${styles$2.ctn} ${theme === "light" ? styles$2.light : ""}`,
    ref: ctnRef
  }, {
    children: [jsxs("div", Object.assign({
      className: styles$2.content,
      style: {
        alignItems: align
      }
    }, {
      children: [jsxs("div", Object.assign({
        className: styles$2.textBox
      }, {
        children: [jsxs("div", Object.assign({
          className: styles$2.headerBox
        }, {
          children: [jsx(Text, Object.assign({
            figmaStyle: "eyebrow",
            label: "h2"
          }, {
            children: eyebrow
          })), cameraNameAnimation === "blur" ? jsx(CameraStyleWrap$1, {
            children: jsx("div", Object.assign({
              className: styles$2.modelTextBox,
              style: {
                gridTemplateRows: `repeat(${model.length}, 100%)`
              }
            }, {
              children: model.map((item, index) => {
                return jsx(Text, Object.assign({
                  figmaStyle: "header-2",
                  label: "h3",
                  className: `${styles$2.modelItem} ${styles$2.blurEffect}`
                }, {
                  children: item
                }), index);
              })
            }))
          }) : jsx("div", Object.assign({
            className: `detail-header-2`
          }, {
            children: jsx("div", Object.assign({
              className: styles$2.modelTextBox,
              style: {
                gridTemplateRows: `repeat(${model.length}, 100%)`,
                overflow: "hidden"
              }
            }, {
              children: model.map((item, index) => {
                return jsx(Text, Object.assign({
                  figmaStyle: "header-2",
                  label: "h3",
                  className: styles$2.modelItem
                }, {
                  children: item
                }), index);
              })
            }))
          })), jsx(Text, Object.assign({
            figmaStyle: "header-1",
            label: "h3"
          }, {
            children: header
          }))]
        })), jsxs("div", Object.assign({
          className: styles$2.describe
        }, {
          children: [body ? jsx(Text, Object.assign({
            figmaStyle: "body",
            label: "p",
            className: styles$2.body
          }, {
            children: body
          })) : "", note ? jsx(Text, Object.assign({
            figmaStyle: "note",
            label: "p",
            className: styles$2.note
          }, {
            children: note
          })) : ""]
        })), jsxs("a", Object.assign({
          href: href,
          className: styles$2.seeCameraListButton
        }, {
          children: [jsx(Text, Object.assign({
            figmaStyle: "body-2",
            label: "p"
          }, {
            children: textData[0]
          })), jsxs("svg", Object.assign({
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, {
            children: [jsx("path", {
              d: "M21 12.5H3",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }), jsx("path", {
              d: "M13.9155 5.5L21.0001 12.5L13.9155 19.5",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })]
          }))]
        }))]
      })), jsxs("div", Object.assign({
        className: styles$2.modelOperateBox
      }, {
        children: [jsxs("div", Object.assign({
          className: styles$2.modelBox
        }, {
          children: [jsxs("div", Object.assign({
            className: styles$2.horizontalBox
          }, {
            children: [jsx("div", Object.assign({
              className: styles$2.idlerBox
            }, {
              children: horizontalCombinations.idler.map((item, index) => {
                return jsx(animated.div, Object.assign({
                  className: styles$2.idlerItem,
                  style: Object.assign({}, idlerItemSprings[index])
                }, {
                  children: item.map(img => jsx(Image, Object.assign({}, img)))
                }));
              })
            })), jsx("div", Object.assign({
              className: styles$2.cameraBox
            }, {
              children: horizontalCombinations.camera.map((item, index) => {
                return jsxs("div", Object.assign({
                  className: styles$2.cameraItem
                }, {
                  children: [item.cameraStatic.map(img => jsx(animated.div, Object.assign({
                    style: Object.assign(Object.assign({}, baseSprings[index]), {
                      position: "relative",
                      zIndex: img.zIndex
                    })
                  }, {
                    children: jsx(Image, Object.assign({}, img))
                  }))), item.cameraDynamic.map(img => jsx(animated.div, Object.assign({
                    style: Object.assign(Object.assign(Object.assign({}, cameraDisplacementHorizontalSprings[index]), cameraOpacityHorizontalSprings[index]), {
                      position: "relative",
                      zIndex: img.zIndex
                    })
                  }, {
                    children: jsx(Image, Object.assign({}, img))
                  })))]
                }));
              })
            }))]
          })), verticalCombinations ? jsxs(animated.div, Object.assign({
            className: styles$2.verticalBox
          }, {
            children: [jsx("div", Object.assign({
              className: styles$2.idlerBox
            }, {
              children: verticalCombinations.idler.map((item, index) => {
                return jsx(animated.div, Object.assign({
                  className: styles$2.idlerItem,
                  style: Object.assign({}, idlerItemSprings[index])
                }, {
                  children: jsx(animated.div, Object.assign({
                    style: Object.assign({}, verticalBoxOpacitySpring)
                  }, {
                    children: item.map(img => jsx(Image, Object.assign({}, img)))
                  }))
                }));
              })
            })), jsx("div", Object.assign({
              className: styles$2.cameraBox
            }, {
              children: verticalCombinations.camera.map((item, index) => {
                return jsx(animated.div, Object.assign({
                  className: styles$2.cameraItem
                }, {
                  children: jsx(animated.div, Object.assign({
                    style: Object.assign(Object.assign({}, cameraDisplacementVerticalSprings[index]), cameraOpacityVerticalSprings[index])
                  }, {
                    children: item.map(img => jsx(Image, Object.assign({}, img)))
                  }))
                }));
              })
            }))]
          })) : ""]
        })), jsxs("div", Object.assign({
          className: `${styles$2.buttonBox} detail-body-2`
        }, {
          children: [jsx("button", Object.assign({
            className: styles$2.lastButton,
            onClick: prevWord
          }, {
            children: jsxs("svg", Object.assign({
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, {
              children: [jsx("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
              }), jsx("path", {
                d: "M13 15l-3 -3l3 -3"
              })]
            }))
          })), jsxs("div", {
            children: [verticalCombinations ? jsxs("button", Object.assign({
              onClick: e => {
                const button = e.target;
                button.classList.toggle(`${styles$2.horizontal}`);
                if (currentState.current === "horizontal") {
                  toVertical();
                } else if (currentState.current === "vertical") {
                  toHorizontal();
                }
              },
              className: `${styles$2.currentStateToggleButton} ${styles$2.horizontal}`
            }, {
              children: [jsx("div", {
                className: styles$2.tab
              }), jsx(Text, Object.assign({
                figmaStyle: "body-2",
                className: styles$2.horizontalText
              }, {
                children: textData === null || textData === void 0 ? void 0 : textData[1]
              })), jsx(Text, Object.assign({
                figmaStyle: "body-2",
                className: styles$2.verticalText
              }, {
                children: textData === null || textData === void 0 ? void 0 : textData[2]
              }))]
            })) : "", jsx(TabBar, {
              model: props.model,
              nextWord: nextWord,
              haveVerticalCombinations: verticalCombinations ? true : false
            })]
          }), jsx("button", Object.assign({
            className: styles$2.nextButton,
            onClick: nextWord
          }, {
            children: jsxs("svg", Object.assign({
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, {
              children: [jsx("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
              }), jsx("path", {
                d: "M11 9l3 3l-3 3"
              })]
            }))
          }))]
        }))]
      }))]
    })), jsxs("div", Object.assign({
      className: styles$2.describeMobile
    }, {
      children: [body ? jsx(Text, Object.assign({
        figmaStyle: "body",
        label: "p",
        className: styles$2.body
      }, {
        children: body
      })) : "", note ? jsx(Text, Object.assign({
        figmaStyle: "note",
        label: "p",
        className: styles$2.note
      }, {
        children: note
      })) : ""]
    })), jsxs("a", Object.assign({
      href: href,
      className: styles$2.seeCameraListButtonMobile
    }, {
      children: [jsx(Text, Object.assign({
        figmaStyle: "body-2",
        label: "p"
      }, {
        children: textData[0]
      })), jsxs("svg", Object.assign({
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, {
        children: [jsx("path", {
          d: "M21 12.5H3",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }), jsx("path", {
          d: "M13.9155 5.5L21.0001 12.5L13.9155 19.5",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })]
      }))]
    }))]
  }));
}
const CameraStyleWrap$1 = props => {
  return jsxs("div", Object.assign({
    className: styles$2.cameraStyleWrap
  }, {
    children: [jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        left: "-1px",
        top: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M9 1H1V9"
      })
    })), jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        right: "-1px",
        top: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M8 9L8 1L0 1"
      })
    })), jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        right: "-1px",
        bottom: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M0 8L8 8V0"
      })
    })), jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        bottom: "-1px",
        left: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M1 0L1 8H9"
      })
    })), jsxs("div", Object.assign({
      className: styles$2.modelBox
    }, {
      children: [" ", props.children]
    }))]
  }));
};
const TabBar = props => {
  return jsx("div", Object.assign({
    className: styles$2.tabCtn,
    style: {
      gridTemplateColumns: `repeat(${props.model.length},calc((100% - var(--deatil-carry-tab-gap) * ${props.model.length - 1}) / ${props.model.length}))`,
      position: props.haveVerticalCombinations ? "absolute" : "unset"
    }
  }, {
    children: props.model.map(() => {
      return jsx("div", Object.assign({
        className: styles$2.lineBox
      }, {
        children: jsx("div", {
          className: `${styles$2.line}`,
          onAnimationEnd: () => {
            console.log("end");
            props.nextWord();
          }
        })
      }));
    })
  }));
};
const setTabActiveClassName = activeIndex => {
  const parentElement = document.querySelector(`.${styles$2.tabCtn}`);
  const elements = parentElement.childNodes;
  Array.prototype.forEach.call(elements, (item, index) => {
    item.classList.remove("active");
    void item.offsetWidth;
    if (index === activeIndex) {
      item.classList.add("active");
    }
  });
};

var styles$1 = {"ctn":"photography2-0-module_ctn__vtSqd","content":"photography2-0-module_content__j263p","video":"photography2-0-module_video__6hWKw","header":"photography2-0-module_header__6ujpb","body":"photography2-0-module_body__4JxJ-","svg":"photography2-0-module_svg__nTXP8","svgTextMask":"photography2-0-module_svgTextMask__xtpEn"};

gsap$1.registerPlugin(ScrollTrigger$1);
function Photography20(props) {
  const ctnRef = useRef(null);
  const svgTextMaskRef = useRef(null);
  const headerRef = useRef(null);
  const bodyRef = useRef(null);
  useRef(null);
  const contentRef = useRef(null);
  const svgRectRef = useRef(null);
  useEffect(() => {
    var _a, _b;
    const header = (_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.getDOMNode();
    const body = (_b = bodyRef.current) === null || _b === void 0 ? void 0 : _b.getDOMNode();
    const content = contentRef.current;
    const ctx = gsap$1.context(() => {
      const tl = gsap$1.timeline({
        scrollTrigger: {
          trigger: ctnRef.current,
          pin: true,
          start: "top bottom",
          endTrigger: content,
          end: "240%",
          // markers: true,
          scrub: 1
        }
      });
      tl.to(svgTextMaskRef.current, {
        transform: "scale(1)",
        duration: 4
      });
      tl.to(svgRectRef.current, {
        opacity: 0.5,
        duration: 1
      }, 4);
      tl.to(svgTextMaskRef.current, {
        opacity: 1,
        duration: 1
      }, 0);
      tl.to(svgTextMaskRef.current, {
        opacity: 0,
        duration: 1
      }, 4);
      tl.to(header, {
        transform: "translateY(0px) scale(1)",
        duration: 3
      }, 5);
      tl.to(header, {
        opacity: 1,
        duration: 1
      }, 5);
      tl.to(header, {
        opacity: 0,
        duration: 1
      }, 7);
      tl.to(body, {
        transform: "translateY(0px) scale(1)",
        duration: 3
      }, 8);
      tl.to(body, {
        opacity: 1,
        duration: 1
      }, 8);
      // tl.to(
      //   body,
      //   {
      //     opacity: 0,
      //     duration: 1,
      //   },
      //   13
      // );
    });

    return () => ctx.revert();
  }, []);
  return jsx("div", Object.assign({
    className: styles$1.ctn,
    ref: ctnRef
  }, {
    children: jsxs("div", Object.assign({
      className: styles$1.content,
      ref: contentRef
    }, {
      children: [jsx(Video, Object.assign({}, props.videoProps, {
        className: styles$1.video
      })), jsxs("svg", Object.assign({
        className: styles$1.svg
      }, {
        children: [jsxs("mask", Object.assign({
          id: "photography-mask"
        }, {
          children: [jsx("rect", {
            fill: "white",
            width: "100%",
            height: "100%"
          }), jsx("text", Object.assign({
            "dominant-baseline": "central",
            "text-anchor": "middle",
            x: "50%",
            y: "50%",
            fill: "black",
            className: styles$1.svgTextMask,
            ref: svgTextMaskRef
          }, {
            children: "2.0"
          }))]
        })), jsx("rect", {
          fill: "black",
          width: "100%",
          height: "100%",
          mask: "url(#photography-mask)",
          ref: svgRectRef
        })]
      })), jsx(Text, Object.assign({
        figmaStyle: "header-1",
        label: "h1",
        ref: headerRef,
        className: styles$1.header
      }, {
        children: props.header
      })), jsx(Text, Object.assign({
        figmaStyle: "introduction",
        label: "h2",
        ref: bodyRef,
        className: styles$1.body
      }, {
        children: props.body
      }))]
    }))
  }));
}

var styles = {"ctn":"carry-effect-module_ctn__v5Yyg","modelItem":"carry-effect-module_modelItem__PNhbp","blurEffect":"carry-effect-module_blurEffect__U8-q4","modelTextBox":"carry-effect-module_modelTextBox__5tCgX","triggers":"carry-effect-module_triggers__n7eu-","trigger":"carry-effect-module_trigger__pcIJc","cameraStyleWrap":"carry-effect-module_cameraStyleWrap__eoAet","modelBox":"carry-effect-module_modelBox__RYJGx","horizontalBox":"carry-effect-module_horizontalBox__klTZ9","verticalBox":"carry-effect-module_verticalBox__pBSXd","idlerBox":"carry-effect-module_idlerBox__dL0o9","cameraBox":"carry-effect-module_cameraBox__velDf","idlerItem":"carry-effect-module_idlerItem__QRGbw","cameraItem":"carry-effect-module_cameraItem__r1I4a","toVerticalButton":"carry-effect-module_toVerticalButton__bKHbR","toHorizontalButton":"carry-effect-module_toHorizontalButton__08WsZ","horizontal":"carry-effect-module_horizontal__G2vV1","currentStateToggleButton":"carry-effect-module_currentStateToggleButton__tQo0I","seeCameraListButton":"carry-effect-module_seeCameraListButton__DpgOW","seeCameraListButtonMobile":"carry-effect-module_seeCameraListButtonMobile__UlJrp","light":"carry-effect-module_light__9vq6x","textBox":"carry-effect-module_textBox__f-HVq","modelOperateBox":"carry-effect-module_modelOperateBox__qSdrJ"};

gsap.registerPlugin(ScrollTrigger, Observer, ScrollToPlugin);
function CarryEffect(props) {
  const {
    eyebrow,
    header,
    body,
    model,
    horizontalCombinations,
    verticalCombinations,
    textData,
    cameraNameAnimation = "transfer",
    trigger,
    markers = false,
    theme,
    href
  } = props;
  const ctnRef = useRef(null);
  const currentIndex = useRef(0);
  const currentState = useRef("horizontal");
  const modelGSAPArray = useRef([]);
  const intentObserver = useRef();
  const preventScroll = useRef();
  const animating = useRef(false);
  const scrollTop = useRef(0);
  const cameraDisplacements = {
    horizontal: {
      x: -120,
      y: 60
    },
    vertical: {
      x: 160,
      y: 24
    }
  };
  console.log(horizontalCombinations);
  // idlerAnimation
  const [idlerItemSprings, setIdlerItemSprings] = useSprings(horizontalCombinations.idler.length, i => {
    return {
      opacity: i <= currentIndex.current ? 1 : 0
    };
  });
  // cameraAnimationHorizontal
  const [cameraDisplacementHorizontalSprings, setCameraDisplacementHorizontalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      y: i === currentIndex.current && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.y,
      x: i === currentIndex.current && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.x,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  const [cameraOpacityHorizontalSprings, setCameraOpacityHorizontalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current && currentState.current === "horizontal" ? 1 : 0,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  // cameraAnimationVertical
  const [cameraDisplacementVerticalSprings, setCameraDisplacementVerticalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      y: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
      x: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  const [cameraOpacityVerticalSprings, setCameraOpacityVerticalSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current && currentState.current === "vertical" ? 1 : 0,
      config: {
        tension: 170,
        friction: 26
      }
    };
  });
  useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current ? 1 : 0
    };
  });
  // vertical box animation
  const [verticalBoxOpacitySpring, setVerticalBoxOpacitySpring] = useSpring(() => {
    return {
      opacity: currentState.current === "horizontal" ? 0 : 1
    };
  });
  const [baseSprings, setBaseSprings] = useSprings(horizontalCombinations.camera.length, i => {
    return {
      opacity: i === currentIndex.current ? 1 : 0,
      y: 0,
      x: 0
    };
  });
  useEffect(() => {
    const ctx = gsap.context(() => {
      modelGSAPArray.current = gsap.utils.toArray(`.${styles.modelItem}`);
      if (cameraNameAnimation === "blur") {
        gsap.set(modelGSAPArray.current, {
          opacity: i => i === currentIndex.current ? 1 : 0
        });
        gsap.set(document.querySelector(`.${styles.modelBox}`), {
          width: modelGSAPArray.current[currentIndex.current].clientWidth
        });
      }
      // create an observer and disable it to start
      intentObserver.current = ScrollTrigger.observe({
        type: "wheel,touch",
        onUp: () => !animating.current && animation(currentIndex.current + 1, true),
        onDown: () => !animating.current && animation(currentIndex.current - 1, false),
        wheelSpeed: -1,
        tolerance: 10,
        preventDefault: true,
        onPress: self => {
          // on touch devices like iOS, if we want to prevent scrolling, we must call preventDefault() on the touchstart (Observer doesn't do that because that would also prevent side-scrolling which is undesirable in most cases)
          ScrollTrigger.isTouch && self.event.preventDefault();
        }
      });
      intentObserver.current.disable();
      preventScroll.current = ScrollTrigger.observe({
        preventDefault: true,
        type: "wheel,scroll",
        allowClicks: true,
        onEnable: self => scrollTop.current = self.scrollY(),
        onChangeY: self => self.scrollY(scrollTop.current) // refuse to scroll
      });

      preventScroll.current.disable();
      // pin swipe section and initiate observer
      ScrollTrigger.create({
        trigger: trigger !== null && trigger !== void 0 ? trigger : ctnRef.current,
        pin: true,
        anticipatePin: 1,
        start: "top top",
        end: "+=0",
        markers: markers,
        onEnter: self => {
          var _a, _b;
          if (((_a = preventScroll.current) === null || _a === void 0 ? void 0 : _a.isEnabled) === false) {
            self.scroll(self.start);
            preventScroll.current.enable();
            (_b = intentObserver.current) === null || _b === void 0 ? void 0 : _b.enable();
            animation(currentIndex.current + 1, true);
          }
        },
        onEnterBack: self => {
          var _a, _b;
          if (((_a = preventScroll.current) === null || _a === void 0 ? void 0 : _a.isEnabled) === false) {
            self.scroll(self.start);
            preventScroll.current.enable();
            (_b = intentObserver.current) === null || _b === void 0 ? void 0 : _b.enable();
            animation(currentIndex.current - 1, false);
          }
        }
      });
    });
    return () => ctx.revert();
  });
  const animation = (index, isScrollingDown) => {
    var _a, _b, _c;
    console.log(index);
    animating.current = true;
    if (index === model.length && isScrollingDown || index === -1 && !isScrollingDown) {
      (_a = intentObserver.current) === null || _a === void 0 ? void 0 : _a.disable();
      (_b = preventScroll.current) === null || _b === void 0 ? void 0 : _b.disable();
      animating.current = false;
      // now make it go 1px beyond in the correct direction so that it doesn't trigger onEnter/onEnterBack.
      (_c = preventScroll.current) === null || _c === void 0 ? void 0 : _c.scrollY(preventScroll.current.scrollY() + (index === model.length ? 1 : -1));
      return;
    }
    setIdlerItemSprings.start(i => {
      return {
        opacity: i <= index ? 1 : 0
      };
    });
    setCameraDisplacementHorizontalSprings.start(i => {
      return {
        y: i === index && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.y,
        x: i === index && currentState.current === "horizontal" ? 0 : cameraDisplacements.horizontal.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: i === index && currentState.current === "horizontal" ? 600 : 0
      };
    });
    setCameraDisplacementVerticalSprings.start(i => {
      return {
        y: i === index && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
        x: i === index && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: i === index && currentState.current === "vertical" ? 600 : 0
      };
    });
    // setCameraOpacitySprings.start((i) => {
    //   if (currentIndex.current === i) {
    //     return {
    //       opacity: 0,
    //       delay: 300,
    //       config: { tension: 170, friction: 26 },
    //     };
    //   } else if (index === i) {
    //     return {
    //       opacity: 1,
    //       delay: 600,
    //       config: { tension: 170, friction: 26 },
    //     };
    //   }
    //   // return {
    //   //   opacity: i === index ? 1 : 0,
    //   //   delay: i === index ? 540 : 120,
    //   //   config: { tension: 170, friction: 26 },
    //   // };
    // });
    setCameraOpacityHorizontalSprings.start(i => {
      if (currentIndex.current === i && currentState.current === "horizontal") {
        return {
          opacity: 0,
          delay: 300,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else if (index === i && currentState.current === "horizontal") {
        return {
          opacity: 1,
          delay: 600,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else {
        return {
          opacity: 0
        };
      }
    });
    setCameraOpacityVerticalSprings.start(i => {
      if (currentIndex.current === i && currentState.current === "vertical") {
        return {
          opacity: 0,
          delay: 300,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else if (index === i && currentState.current === "vertical") {
        return {
          opacity: 1,
          delay: 600,
          config: {
            tension: 170,
            friction: 26
          }
        };
      }
    });
    setBaseSprings.start(i => {
      if (currentIndex.current === i) {
        return {
          opacity: 0,
          // delay: 540,
          config: {
            tension: 170,
            friction: 26
          }
        };
      } else if (index === i && currentState.current === "horizontal") {
        return {
          opacity: 1,
          // delay: 600,
          config: {
            tension: 170,
            friction: 26
          }
        };
      }
    });
    if (cameraNameAnimation === "blur") {
      gsap.to(modelGSAPArray.current, {
        opacity: i => i === index ? 1 : 0,
        filter: i => i === index ? "blur(0px)" : "blur(40px)",
        duration: 1
      });
      gsap.to(document.querySelector(`.${styles.modelBox}`), {
        width: modelGSAPArray.current[index].clientWidth,
        duration: 1,
        onComplete: () => {
          animating.current = false;
        }
      });
    } else {
      gsap.to(modelGSAPArray.current, {
        yPercent: -100 * index,
        duration: 0.8,
        onComplete: () => {
          animating.current = false;
        }
      });
    }
    currentIndex.current = index;
  };
  const toVertical = () => {
    animating.current = true;
    currentState.current = "vertical";
    // 控制整体的横拍竖拍盒子的不透明度
    setVerticalBoxOpacitySpring.start(() => {
      return {
        opacity: 1,
        delay: 300
      };
    });
    // 控制横拍的相机不透明度动画（消失）
    setCameraOpacityHorizontalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "horizontal" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 300
      };
    });
    // 控制横拍的相机位移动画（卸掉）
    setCameraDisplacementHorizontalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.y : cameraDisplacements.horizontal.y,
        x: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.x : cameraDisplacements.horizontal.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 120
      };
    });
    // 控制竖拍的相机不透明度动画（出现）
    setCameraOpacityVerticalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "vertical" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    setBaseSprings.start(i => {
      return {
        y: cameraDisplacements.vertical.y,
        x: cameraDisplacements.vertical.x,
        opacity: 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 120
      };
    });
    // 控制竖拍的相机位移动画（装上）
    setCameraDisplacementVerticalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
        x: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600,
        onRest: () => {
          animating.current = false;
        }
      };
    });
  };
  const toHorizontal = () => {
    currentState.current = "horizontal";
    // setBaseSprings.start((i) => {
    //   if (currentIndex.current === i) {
    //     return {
    //       opacity: 0,
    //       delay: 540,
    //       config: { tension: 170, friction: 26 },
    //     };
    //   }
    // });
    setVerticalBoxOpacitySpring.start(() => {
      return {
        opacity: 0,
        delay: 300
      };
    });
    setCameraOpacityHorizontalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "horizontal" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    // 这个持续时间为 0 的动画是为了让当前 index 的起始偏移改为从左侧开始，保证在横竖拍切换时，起始位置总为从左侧滑入
    setCameraDisplacementHorizontalSprings.start(i => {
      if (i === currentIndex.current) {
        return {
          y: cameraDisplacements.vertical.y,
          x: cameraDisplacements.vertical.x,
          config: {
            tension: 0,
            friction: 0
          }
        };
      }
    });
    setCameraDisplacementHorizontalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.y : cameraDisplacements.horizontal.y,
        x: i === currentIndex.current && currentState.current === "horizontal" ? 0 : i === currentIndex.current ? cameraDisplacements.vertical.x : cameraDisplacements.horizontal.x,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    setCameraOpacityVerticalSprings.start(i => {
      return {
        opacity: i === currentIndex.current && currentState.current === "vertical" ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 300
      };
    });
    setBaseSprings.start(i => {
      return {
        y: 0,
        x: 0,
        opacity: i === currentIndex.current ? 1 : 0,
        config: {
          tension: 170,
          friction: 26
        },
        delay: 600
      };
    });
    setCameraDisplacementVerticalSprings.start(i => {
      return {
        y: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.y,
        x: i === currentIndex.current && currentState.current === "vertical" ? 0 : cameraDisplacements.vertical.x,
        config: {
          tension: 170,
          friction: 26
        },
        onRest: () => {
          animating.current = false;
        }
      };
    });
  };
  return jsxs("div", Object.assign({
    className: `${styles.ctn} ${theme === "light" ? styles.light : ""}`,
    ref: ctnRef
  }, {
    children: [jsxs("div", Object.assign({
      className: styles.textBox
    }, {
      children: [jsxs("div", Object.assign({
        className: styles.headerBox
      }, {
        children: [jsx(Text, Object.assign({
          figmaStyle: "eyebrow",
          label: "h2"
        }, {
          children: eyebrow
        })), cameraNameAnimation === "blur" ? jsx(CameraStyleWrap, {
          children: jsx("div", Object.assign({
            className: styles.modelTextBox,
            style: {
              gridTemplateRows: `repeat(${model.length}, 100%)`
            }
          }, {
            children: model.map((item, index) => {
              return jsx(Text, Object.assign({
                figmaStyle: "header-2",
                label: "h3",
                className: `${styles.modelItem} ${styles.blurEffect}`
              }, {
                children: item
              }), index);
            })
          }))
        }) : jsx("div", Object.assign({
          className: `detail-header-2`
        }, {
          children: jsx("div", Object.assign({
            className: styles.modelTextBox,
            style: {
              gridTemplateRows: `repeat(${model.length}, 100%)`
            }
          }, {
            children: model.map((item, index) => {
              return jsx(Text, Object.assign({
                figmaStyle: "header-2",
                label: "h3",
                className: styles.modelItem
              }, {
                children: item
              }), index);
            })
          }))
        })), jsx(Text, Object.assign({
          figmaStyle: "header-1",
          label: "h3"
        }, {
          children: header
        }))]
      })), jsx(Text, Object.assign({
        figmaStyle: "body",
        label: "p"
      }, {
        children: body
      })), jsxs("a", Object.assign({
        href: href,
        className: styles.seeCameraListButton
      }, {
        children: [jsx(Text, Object.assign({
          figmaStyle: "body-2",
          label: "p"
        }, {
          children: textData[0]
        })), jsxs("svg", Object.assign({
          width: "24",
          height: "25",
          viewBox: "0 0 24 25",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, {
          children: [jsx("path", {
            d: "M21 12.5H3",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }), jsx("path", {
            d: "M13.9155 5.5L21.0001 12.5L13.9155 19.5",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })]
        }))]
      }))]
    })), jsxs("div", Object.assign({
      className: styles.modelOperateBox
    }, {
      children: [jsxs("div", Object.assign({
        className: styles.modelBox
      }, {
        children: [jsxs("div", Object.assign({
          className: styles.horizontalBox
        }, {
          children: [jsx("div", Object.assign({
            className: styles.idlerBox
          }, {
            children: horizontalCombinations.idler.map((item, index) => {
              return jsx(animated.div, Object.assign({
                className: styles.idlerItem,
                style: Object.assign({}, idlerItemSprings[index])
              }, {
                children: item.map(img => jsx(Image, Object.assign({}, img)))
              }));
            })
          })), jsx("div", Object.assign({
            className: styles.cameraBox
          }, {
            children: horizontalCombinations.camera.map((item, index) => {
              return jsxs("div", Object.assign({
                className: styles.cameraItem
              }, {
                children: [item.cameraStatic.map(img => jsx(animated.div, Object.assign({
                  style: Object.assign(Object.assign({}, baseSprings[index]), {
                    position: "relative",
                    zIndex: img.zIndex
                  })
                }, {
                  children: jsx(Image, Object.assign({}, img))
                }))), item.cameraDynamic.map(img => jsx(animated.div, Object.assign({
                  style: Object.assign(Object.assign(Object.assign({}, cameraDisplacementHorizontalSprings[index]), cameraOpacityHorizontalSprings[index]), {
                    position: "relative",
                    zIndex: img.zIndex
                  })
                }, {
                  children: jsx(Image, Object.assign({}, img))
                })))]
              }));
            })
          }))]
        })), verticalCombinations ? jsxs(animated.div, Object.assign({
          className: styles.verticalBox
        }, {
          children: [jsx("div", Object.assign({
            className: styles.idlerBox
          }, {
            children: verticalCombinations.idler.map((item, index) => {
              return jsx(animated.div, Object.assign({
                className: styles.idlerItem,
                style: Object.assign({}, idlerItemSprings[index])
              }, {
                children: jsx(animated.div, Object.assign({
                  style: Object.assign({}, verticalBoxOpacitySpring)
                }, {
                  children: item.map(img => jsx(Image, Object.assign({}, img)))
                }))
              }));
            })
          })), jsx("div", Object.assign({
            className: styles.cameraBox
          }, {
            children: verticalCombinations.camera.map((item, index) => {
              return jsx(animated.div, Object.assign({
                className: styles.cameraItem
              }, {
                children: jsx(animated.div, Object.assign({
                  style: Object.assign(Object.assign({}, cameraDisplacementVerticalSprings[index]), cameraOpacityVerticalSprings[index])
                }, {
                  children: item.map(img => jsx(Image, Object.assign({}, img)))
                }))
              }));
            })
          }))]
        })) : ""]
      })), verticalCombinations ? jsxs("button", Object.assign({
        onClick: e => {
          const button = e.target;
          button.classList.toggle(`${styles.horizontal}`);
          if (currentState.current === "horizontal") {
            toVertical();
          } else if (currentState.current === "vertical") {
            toHorizontal();
          }
        },
        className: `${styles.currentStateToggleButton} ${styles.horizontal}`
      }, {
        children: [jsx("svg", Object.assign({
          width: "24",
          height: "25",
          viewBox: "0 0 24 25",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, {
          children: jsx("path", {
            d: "M9.82843 5.5L7.82843 7.5L4 7.5L4 19.5L20 19.5L20 7.5L16.1716 7.5L14.1716 5.5H9.82843ZM9 3.5L15 3.5L17 5.5L21 5.5C21.5523 5.5 22 5.94772 22 6.5L22 20.5C22 21.0523 21.5523 21.5 21 21.5L3 21.5C2.44772 21.5 2 21.0523 2 20.5L2 6.5C2 5.94772 2.44772 5.5 3 5.5L7 5.5L9 3.5ZM9.64042 8.03044C10.3555 7.69033 11.1555 7.5 12 7.5C15.0376 7.5 17.5 9.96243 17.5 13C17.5 14.55 16.8588 15.9502 15.8273 16.9499L13.75 13.1H15.4986C15.4995 13.0668 15.5 13.0334 15.5 13C15.5 11.067 13.933 9.5 12 9.5C11.4912 9.5 11.0078 9.60856 10.5716 9.80378L9.64042 8.03044ZM14.3175 17.9894C13.6132 18.317 12.828 18.5 12 18.5C8.96243 18.5 6.5 16.0376 6.5 13C6.5 11.4678 7.12654 10.0819 8.13738 9.08462L10.25 13H8.5C8.5 14.933 10.067 16.5 12 16.5C12.4923 16.5 12.9608 16.3984 13.3857 16.215L14.3175 17.9894Z",
            fill: "#332F24"
          })
        })), jsxs("div", {
          children: [jsx("div", Object.assign({
            className: styles.toVerticalButton
          }, {
            children: textData === null || textData === void 0 ? void 0 : textData[1]
          })), jsx("div", Object.assign({
            className: styles.toHorizontalButton
          }, {
            children: textData === null || textData === void 0 ? void 0 : textData[2]
          }))]
        })]
      })) : ""]
    })), jsxs("a", Object.assign({
      href: href,
      className: styles.seeCameraListButtonMobile
    }, {
      children: [jsx(Text, Object.assign({
        figmaStyle: "body-2",
        label: "p"
      }, {
        children: textData[0]
      })), jsxs("svg", Object.assign({
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, {
        children: [jsx("path", {
          d: "M21 12.5H3",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }), jsx("path", {
          d: "M13.9155 5.5L21.0001 12.5L13.9155 19.5",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })]
      }))]
    }))]
  }));
}
const CameraStyleWrap = props => {
  return jsxs("div", Object.assign({
    className: styles.cameraStyleWrap
  }, {
    children: [jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        left: "-1px",
        top: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M9 1H1V9"
      })
    })), jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        right: "-1px",
        top: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M8 9L8 1L0 1"
      })
    })), jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        right: "-1px",
        bottom: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M0 8L8 8V0"
      })
    })), jsx("svg", Object.assign({
      width: "9",
      height: "9",
      viewBox: "0 0 9 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        bottom: "-1px",
        left: "-1px"
      }
    }, {
      children: jsx("path", {
        d: "M1 0L1 8H9"
      })
    })), jsxs("div", Object.assign({
      className: styles.modelBox
    }, {
      children: [" ", props.children]
    }))]
  }));
};

export { CarryEffect, CarryEffectAuto, Photography20 };
